export default {
    getFormActions: state => state.formActions,
    getHeaderFields: state => state.headerFields
}
